<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="show"
    @close="onChange"
    class="sku-bind-table-item-modal"
    title
    width="600px"
  >
    <div slot="title">
      {{
        drawRow.type == 'add'
          ? $t('stores::products-info::add_sku')
          : drawRow.type == 'edit'
          ? $t('stores::products-info::edit_sku')
          : $t('stores::products-info::copy_sku')
      }}
    </div>
    <el-form :model="params" :rules="rules" class="user-body" label-position="top" label-width="100px" ref="form">
      <el-form-item label label-width="0" prop="imageUrl">
        <!-- <pictureUpload folder="product" v-model="params.imageUrl" @on-success="uploadSuccess"></pictureUpload> -->
        <div class="upload-wrap" @click="dialogVisible = true">
          <el-image v-if="params.imageUrl" :src="params.imageUrl" class="avatar" fit="contain"></el-image>
          <span class="up-icon" v-else>+</span>
        </div>
      </el-form-item>
      <div class="content-wrapper mt-12">
        <div class="content-title mb-12">{{ $t('stores::products-info::base_info') }}</div>
        <el-row :gutter="8">
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::purchase_price')" prop="purchasePrice">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                v-model="params.purchasePrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::compare_at_price')" prop="compareAtPrice">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                v-model="params.compareAtPrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::sale_price')" prop="salePrice">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                v-model="params.salePrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::safe_stock')" prop="safeInventory">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                v-model="params.safeInventory"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="params && !params.hasOwnProperty('id')">
            <el-form-item :label="$t('stores::products-info::first_stock')" prop="skuInventory">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                v-model="params.skuInventory"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::weight')" prop="weight">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                class="input-item"
                :min="0"
                controls-position="right"
                size="small"
                style="width: 105px"
                v-model="params.weight"
              ></el-input-number>
              <el-select
                :popper-append-to-body="false"
                size="small"
                style="width: 70px;margin-left: 6px;"
                v-model="params.weightUnit"
              >
                <el-option label="g" value="g"></el-option>
                <el-option label="kg" value="kg"></el-option>
                <el-option label="oz" value="oz"></el-option>
                <el-option label="lb" value="lb"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::long')" prop="length">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                :precision="2"
                :min="0"
                class="input-item"
                controls-position="right"
                size="small"
                style="width: 105px"
                v-model="params.length"
              ></el-input-number>
              <el-select
                :popper-append-to-body="false"
                size="small"
                style="width: 70px;margin-left: 6px;"
                v-model="params.sizeUnit"
              >
                <el-option label="cm" value="cm"></el-option>
                <el-option label="m" value="m"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::width')" prop="wide">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                :precision="2"
                :min="0"
                class="input-item"
                controls-position="right"
                size="small"
                style="width: 105px"
                v-model="params.wide"
              ></el-input-number>
              <el-select
                :popper-append-to-body="false"
                size="small"
                style="width: 70px;margin-left: 6px;"
                v-model="params.sizeUnit"
              >
                <el-option label="cm" value="cm"></el-option>
                <el-option label="m" value="m"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('stores::products-info::height')" prop="high">
              <el-input-number
                :placeholder="$t('system::common::input_holder')"
                :precision="2"
                :min="0"
                class="input-item"
                controls-position="right"
                size="small"
                style="width: 105px"
                v-model="params.high"
              ></el-input-number>
              <el-select
                :popper-append-to-body="false"
                size="small"
                style="width: 70px;margin-left: 6px;"
                v-model="params.sizeUnit"
              >
                <el-option label="cm" value="cm"></el-option>
                <el-option label="m" value="m"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template>
          <div>
            <div class="content-title mb-12">{{ $t('stores::products-info::attr_info') }}</div>
            <el-row :gutter="8" v-if="params.options && params.options.length">
              <el-col :key="index" :span="8" v-for="(item, index) in params.options">
                <el-form-item
                  :label="item.name"
                  :prop="item.name"
                  :rules="{
                    required: true,
                    message: `${$t('system::common::input_holder')}${item.name}`,
                    trigger: 'blur'
                  }"
                  v-if="item.list && item.list.length"
                >
                  <el-select
                    :placeholder="`${$t('system::common::input_holder')}${item.name}`"
                    :popper-append-to-body="false"
                    size="small"
                    style="width: 100%"
                    v-model="params[item.name]"
                  >
                    <el-option
                      :key="i"
                      :label="option.value"
                      :value="option.value"
                      v-for="(option, i) in item.list"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="item.name"
                  :prop="item.name"
                  :rules="{
                    required: true,
                    message: `${$t('system::common::input_holder')}${item.name}`,
                    trigger: 'blur'
                  }"
                  v-else
                >
                  <el-input
                    :placeholder="`${$t('system::common::input_holder')}${item.name}`"
                    size="small"
                    v-model="params[item.name]"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-else>
              <el-button @click="onAddAttr" icon="el-icon-plus" size="small">添加属性</el-button>
            </template>
          </div>
        </template>
      </div>
    </el-form>

    <div class="dialog-footer" slot="footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button :loading="loading" @click="onSave" type="primary">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
    <ImgList v-model="dialogVisible" :images="images" @select="selectImg"></ImgList>
  </el-dialog>
</template>
<script>
import pictureUpload from '@/components/common/picture-upload'
import ImgList from '@/views/commodity-center/products/product-info/components/img-list.vue'
export default {
  name: 'sku-modal',
  components: {
    pictureUpload,
    ImgList
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    data: {
      default: () => []
    },
    selectedSkuOpt: {
      default: () => []
    },
    drawRow: {
      default: () => {}
    },
    images: {
      default: () => []
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      if (bool) {
        this.params = {
          ...data.item
        }
        if (data.item.options && data.item.options.length) {
          data.item.options.forEach(item => {
            this.$set(this.params, item.name, item.value)
          })
        }
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      rules: {
        imageUrl: [{ required: true, message: this.$t('stores::products-info::select_photos'), trigger: 'change' }],
        skuInventory: [
          { required: true, message: this.$t('stores::products-info::input_first_stock'), trigger: 'blur' }
        ],
        safeInventory: [
          { required: true, message: this.$t('stores::products-info::input_safe_stock'), trigger: 'blur' }
        ],
        compareAtPrice: [
          { required: true, message: this.$t('stores::products-info::input_at_price'), trigger: 'blur' }
        ],
        purchasePrice: [
          { required: true, message: this.$t('stores::products-info::input_purchase_price'), trigger: 'blur' }
        ],
        weight: [{ required: true, message: this.$t('stores::products-info::input_weight'), trigger: 'blur' }],
        salePrice: [{ required: true, message: this.$t('stores::products-info::input_sale_price'), trigger: 'blur' }]
      },
      show: false,
      params: {},
      dialogVisible: false
    }
  },
  mounted() {},
  methods: {
    uploadSuccess() {
      this.$refs['form'].clearValidate('imageUrl')
    },
    updateAttr() {
      const data = this.drawRow
      if (data.item.options && data.item.options.length) {
        data.item.options.forEach(item => {
          this.$set(this.params, item.name, item.value)
        })
        this.params.options = data.item.options
        console.log('数据结构，', data.item, this.params)
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    onAddAttr() {
      this.$emit('onAddAttr')
    },
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (
            this.data.length === 1 &&
            !this.params.options.length &&
            (this.drawRow.type === 'add' || this.drawRow.type === 'copy')
          ) {
            this.$message.warning(this.$t('stores::products-info::message_one_sku'))
            return false
          }
          let params = {
            ...this.params
          }
          let optionError = 0

          if (params.options) {
            // sku数据赋值
            params.options = params.options.map(item => {
              const data = params[item.name]
              delete params[item.name]
              return {
                ...item,
                value: data
              }
            })
            // 对比 table数据，当前添加的sku属性值是否重复，重复报错提示
            console.log(params.options, params, this.data, '对比')
            const compareStr = params.options.map(item => item.value).join('')
            this.data.forEach(dataItem => {
              if (
                (params.hasOwnProperty('fakeId') && dataItem.fakeId !== params.fakeId) ||
                (params.hasOwnProperty('id') && dataItem.id !== params.id)
              )
                if (compareStr === dataItem.options.map(opt => opt.value).join('')) {
                  optionError += 1
                }
            })

            if (optionError !== 0) {
              this.$message.warning(this.$t('stores::products-info::message_not_same'))
              return false
            }
          }
          this.$emit('save', params, this.drawRow.type)
          this.$emit('change', false)
        }
      })
    },
    handleCheck(type) {
      this.$refs.form.resetFields()
      this.params.type = type
    },
    selectImg(url) {
      this.params.imageUrl = url
    }
  }
}
</script>
<style lang="scss" scoped>
.sku-bind-table-item-modal {
  .content-title {
    font-weight: bold;
  }
  .content-wrapper {
    .input-item {
      width: 100%;
    }
  }
  .upload-wrap {
    box-sizing: border-box;
    padding: 4px;
    width: 80px;
    height: 80px;
    margin-right: 8px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: #3a416f;
    .up-icon {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 30px;
    }
  }
}
</style>
